<template>
  <div>
<!--    <div class="tab__content">-->
<!--      <div class="tab__content__item tab__active">-->
<!--        <h4 class="tab__content__title">{{ $lang.app.RESOLUTIONS }}</h4>-->
<!--        <div class="resolution__list">-->
<!--          <div v-for="resolution in resolutions" :key="resolution.id" class="resolution__item">-->
<!--            <ResolutionItem :resolution="resolution"/>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <ResolutionDetailModal/>-->


    <div class="tab__content">
      <div class="tab__content__item tab__active">
        <h4 class="tab__content__title">{{ $lang.app.RESOLUTIONS }}</h4>
        <div class="row">
          <div class="col-lg-6">
            <Loader v-if="loading"/>
            <div v-else class="resolution__list">
              <div v-for="resolution in resolutions" :key="resolution.id" class="resolution__item">
                <ResolutionItem :resolution="resolution"/>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <router-view/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import resolutionApi from "../../../api/employee/resolution";
import ResolutionItem from "../../../components/employee/application/resolution/ResolutionItem";
import {getValueByKey as resolutionStatusesVBK} from "../../../helpers/constants/resolutionStatuses";
// import ResolutionDetailModal from "../../../components/employee/application/resolution/modals/ResolutionDetailModal.vue";

export default {
  components: {
    ResolutionItem,
    // ResolutionDetailModal,
  },
  data() {
    return {
      loading: false,
      resolutions: [],

      open: false,
      tempResolution: null,
    }
  },
  created() {
    this.fetchResolutions()
  },
  watch: {
    '$route'(value) {
      if(value.name === 'EmployeeApplicationResolutions') {
        this.fetchResolutions()
      }
    }
  },
  methods: {
    resolutionStatusesVBK,
    checkResolution(resolution) {
      if(resolution.employees?.some(executor => executor.id === this.$store.getters.getCurrentUser.employment.id)) {
        if(this.tempResolution) {
          if(this.tempResolution.status !== this.resolutionStatusesVBK('FINISH')) {
            if(resolution.status !== this.resolutionStatusesVBK('FINISH')) {
              this.open = false
            }
          } else {
            if(resolution.status !== this.resolutionStatusesVBK('FINISH')) {
              this.tempResolution = resolution
              this.open = true
            } else {
              this.open = false
            }
          }
        } else {
          this.tempResolution = resolution
          this.open = true
        }
      }
    },
    redirectUser() {
      this.open = false
      this.tempResolution = null
      this.resolutions.forEach(resolution => {
        this.checkResolution(resolution)
        resolution.children?.forEach(childResolution => {
          this.checkResolution(childResolution)
        })
      })
      if(this.open) {
        this.$router.push({
          name: 'EmployeeApplicationResolution',
          params: {
            applicationId: this.$route.params.applicationId,
            resolutionId: this.tempResolution.id
          }
        })
      }
    },
    fetchResolutions(reload = true) {
      if(reload) {
        this.loading = true
      }
      resolutionApi.getApplicationResolutions(this.$route.params.applicationId)
          .then(res => {
            this.resolutions = res
            if(this.$route.name === 'EmployeeApplicationResolutions') {
              this.redirectUser()
            }
          }).finally(() => {
        this.loading = false
      })
    },
  },
  beforeMount() {
    this.$emitter.on('refresh-resolutions', (payload) => {
      if(!payload) {
        this.fetchResolutions()
      } else {
        this.fetchResolutions(payload.reload)
      }
    })
  },
  beforeUnmount() {
    this.$emitter.off('refresh-resolutions')
  }
}
</script>
